import React from 'react';
import { observer } from 'mobx-react';

import { classes } from '~utils/ClassNames';
import {
    DropdownWrapper,
    DropdownSelect,
    DropdownOption
} from '~sharedComponents/Dropdown/DropdownStyles';

export interface IDropdown {
    selectedOption: string;
    options: { label: string; value: string }[];
    onChange: React.ChangeEventHandler<HTMLSelectElement>;
    className?: string;
    isRequired?: boolean;
    isDisabled?: boolean;
}

const dropdownName = 'dropdown';
const dropdownOptionClass = classes(`${dropdownName}-option`);
const dropdownWrapperClass = classes(`${dropdownName}-wrapper`);

export const Dropdown = observer((props: IDropdown) => {
    const { selectedOption, options, className, isDisabled, onChange } = props;

    const dropdownClass = classes(dropdownName, className);

    return (
        <DropdownWrapper className={dropdownWrapperClass}>
            <DropdownSelect
                className={dropdownClass}
                value={selectedOption}
                disabled={isDisabled}
                onChange={onChange}
            >
                {options.map(({ value, label }) => (
                    <DropdownOption className={dropdownOptionClass} value={value} key={value}>
                        {label}
                    </DropdownOption>
                ))}
            </DropdownSelect>
        </DropdownWrapper>
    );
});
